import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getQaSelector } from '../../../../utils/common'
import Text from '../../../Text'
import { useGretaAIChatContext } from '../../GretaAIChat.hooks'
import { getIsGretaAIChatFinanceSource } from '../../GretaAIChat.utils.source'
import { GretaAIChatChatMenu } from '../../GretaAIChatChatMenu'
import { QA_NAME_GRETA_AI_CHAT_CHAT } from '../GretaAIChatChatList.constants'

import { getGretaAIChatChatListItemSubtitle } from './GretaAIChatChatListItem.utils'
import { GretaAIChatChatListItemStatus } from './GretaAIChatChatListItemStatus'

import * as styles from './GretaAIChatChatListItem.module.css'

function GretaAIChatChatListItem({
  chat,
  isActive = false,
  isNested = false,
  locale,
  now,
  status = null,
  withRowActions = true,
  onSelect,
}) {
  const { t } = useTranslation()

  const { actions, source } = useGretaAIChatContext()

  const { onDeleteChat, onRenameChat, onRowMenuOpenChange } = actions

  const { isSourceChoiceEnabled } = source

  const subtitle = getGretaAIChatChatListItemSubtitle({
    chat,
    isSourceChoiceEnabled,
    locale,
    now,
    t,
  })

  const isFinance = getIsGretaAIChatFinanceSource(chat.source)

  function handleClick() {
    onSelect(chat.id)
  }

  return (
    <li className={styles.itemRow}>
      <button
        {...getQaSelector({
          context: chat.id,
          value: QA_NAME_GRETA_AI_CHAT_CHAT,
        })}
        className={classNames(styles.item, {
          [styles.itemActive]: isActive,
          [styles.itemNested]: isNested,
        })}
        type='button'
        onClick={handleClick}
      >
        <Text className={styles.itemTitle}>
          {chat.title || t('Greta.NewChatKey')}
        </Text>
        {subtitle ? (
          <Text isSecondary className={styles.itemSubtitle}>
            {subtitle}
          </Text>
        ) : null}
      </button>
      {status ? (
        <GretaAIChatChatListItemStatus
          className={styles.status}
          isFinance={isFinance}
          status={status}
        />
      ) : null}
      {withRowActions ? (
        <GretaAIChatChatMenu
          chat={chat}
          className={styles.menu}
          onDelete={onDeleteChat}
          onOpenChange={onRowMenuOpenChange}
          onRename={onRenameChat}
        />
      ) : null}
    </li>
  )
}

export default GretaAIChatChatListItem
